var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form__formrow" }, [
    _c("p", { class: { " form__row": _vm.returnEnvelopeCheck } }, [
      _c("span", { staticClass: "modal__control_label text--left" }, [
        _vm._v(
          "\n      " +
            _vm._s(this.config.lang["modal.control.return-envelope-header"]) +
            "\n      "
        ),
        _c("img", {
          staticClass:
            "ebrief-tooltip tipso_style upload__section_header_tooltip",
          staticStyle: {
            left: "7px",
            position: "relative",
            top: "3px",
            height: "16px"
          },
          attrs: {
            src: "/build/images/info-circle-darkgrey.svg",
            "data-tipso-key": "return-envelope",
            "data-tipso-moveleft": "2",
            "data-tipso-movetop": "1",
            alt: "Info"
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "label",
        {
          staticClass:
            "form__pincheckbox form__pincheckbox--pointer form__pincheckbox--oneline",
          attrs: { for: "bulk-parameter-return-envelope" }
        },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.returnEnvelopeCheck,
                expression: "returnEnvelopeCheck"
              }
            ],
            staticClass: "form__pincheckbox-input",
            attrs: {
              type: "checkbox",
              id: "bulk-parameter-return-envelope",
              name: "bulk-parameter-return-envelope"
            },
            domProps: {
              checked: Array.isArray(_vm.returnEnvelopeCheck)
                ? _vm._i(_vm.returnEnvelopeCheck, null) > -1
                : _vm.returnEnvelopeCheck
            },
            on: {
              change: [
                function($event) {
                  var $$a = _vm.returnEnvelopeCheck,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.returnEnvelopeCheck = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.returnEnvelopeCheck = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.returnEnvelopeCheck = $$c
                  }
                },
                _vm.updateParent
              ]
            }
          }),
          _vm._v(" "),
          _c("span", { staticClass: "form__pincheckbox-border" }),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass:
                "form__pincheckbox-label form__pincheckbox-label--colorblue"
            },
            [
              _c("span", { staticClass: "text--content-bold" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      this.config.lang[
                        "modal.control.return-envelope-checkbox-pt1"
                      ]
                    ) +
                    "\n          "
                ),
                _vm.returnEnvelopeCheck ? _c("br") : _vm._e(),
                _vm._v(" "),
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(
                      this.config.lang[
                        "modal.control.return-envelope-checkbox-pt2"
                      ]
                    )
                  }
                })
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _vm.returnEnvelopeCheck
        ? _c(
            "label",
            {
              staticClass: "modal__control_label--return-envelope ",
              attrs: { for: "bulk-parameter-envelopetype" }
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    this.config.lang[
                      "modal.control.return-envelope-franking-header"
                    ]
                  ) +
                  "\n    "
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "select",
        {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.envelopeType,
              expression: "envelopeType"
            }
          ],
          staticClass: "js-ms-dropdown form__select--modalcontrol form__hide",
          attrs: {
            id: "bulk-parameter-envelopetype",
            name: "parameter-envelopetype"
          },
          on: {
            change: [
              function($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function(o) {
                    return o.selected
                  })
                  .map(function(o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.envelopeType = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              },
              _vm.updateParent
            ]
          }
        },
        _vm._l(this.config.printparameter.bulk.envelopeType.select, function(
          option
        ) {
          return _c("option", { domProps: { value: option.value } }, [
            _vm._v("\n        " + _vm._s(option.text) + "\n      ")
          ])
        }),
        0
      )
    ]),
    _vm._v(" "),
    _vm.returnEnvelopeCheck
      ? _c("p", { staticClass: "form__row --right" }, [
          _c(
            "label",
            {
              staticClass: "modal__control_label--return-envelope",
              attrs: { for: "bulk-parameter-return-address" }
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    this.config.lang[
                      "modal.control.return-envelope-textarea-header"
                    ]
                  ) +
                  "\n    "
              )
            ]
          ),
          _vm._v(" "),
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.returnAddress,
                expression: "returnAddress"
              }
            ],
            staticClass: "dd form__field--textarea-address ",
            attrs: {
              id: "bulk-parameter-return-address",
              name: "parameter-return-address",
              maxlength: "200",
              placeholder: this.config.lang[
                "modal.control.return-envelope-textarea-placeholder"
              ],
              rows: "3"
            },
            domProps: { value: _vm.returnAddress },
            on: {
              input: [
                function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.returnAddress = $event.target.value
                },
                _vm.updateParent
              ]
            }
          }),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "modal__control_label--char-count",
              class: {
                " --warning": _vm.addressCharLeft <= 10
              }
            },
            [
              _vm._v(
                "\n      noch " + _vm._s(_vm.addressCharLeft) + " Zeichen\n    "
              )
            ]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }